import { render, staticRenderFns } from "./International.vue?vue&type=template&id=46aa193f&scoped=true"
import script from "./International.vue?vue&type=script&lang=js"
export * from "./International.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa193f",
  null
  
)

export default component.exports